// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_oj-0";